<!-- TODO: 20.02.2026 Temporary disabled till we figure out the problem with the script-->
<!--<div class="zendesk-rounded" (click)="launchZendesk()">-->
<!--  <span class="icon-i-question"></span>-->
<!--</div>-->
<div class="navbar-hamburger" (click)="toggleMenu(); checkWasChanged()" [class.active]="activeHamburger">
  <span></span>
  <span></span>
  <span></span>
</div>
<div *ngIf="activeHamburger" class="hamburger-menu">
  <div *ngIf="showNavigation && customer.app_location === 'ch'" class="account-switch-wrap">
    <div class="account-switch-button" (click)="checkWasChanged(); activeAccountSwitch = !activeAccountSwitch">
      <ng-container *ngIf="currentAccount?.kind === '3a' && !isCIActive">
        <span class="icon-i-forest"></span> {{ 'productSwitchDropdown.3aAccount' | translate }}
      </ng-container>
      <ng-container *ngIf="currentAccount?.kind === 'grow' && !isCIActive">
        <span class="icon-i-world"></span> {{ 'productSwitchDropdown.sectionTitle.grow' | translate }}
      </ng-container>
      <ng-container *ngIf="currentAccount?.kind === '3b' && !isCIActive">
        <span class="icon-i-tree"></span> {{ 'productSwitchDropdown.3bAccount' | translate }}
      </ng-container>
      <ng-container *ngIf="currentAccount?.kind === 'kid' && !isCIActive">
        <span class="icon-i-sprout"></span> {{ currentAccount?.owner_name }}
      </ng-container>
      <ng-container *ngIf="isCIActive">
        <span class="icon-i-windmill"></span>
        {{ 'productSwitchDropdown.sectionTitle.CI' | translate }}
      </ng-container>
      <span [ngClass]="activeAccountSwitch ? 'icon-i-chevron-up' : 'icon-i-chevron-down'"></span>
    </div>
    <div *ngIf="activeAccountSwitch" class="account-switch-content">
      <!-- 3a pillar option -->
      <ng-container *ngIf="customer.app_location === 'ch'">
        <li class="navbar__sub-category">
          <span>{{ 'productSwitchDropdown.sectionTitle.3a' | translate }}</span>
        </li>
        <li (click)="switchAccount(findCustomerAccount('3a'))" *ngIf="hasAccount('3a')" [class.active]="currentAccount?.kind === '3a' && !isCIActive">
          <span class="icon-i-forest"></span>{{ 'productSwitchDropdown.3aAccount' | translate }}
        </li>
        <li class="add-account" *ngIf="!hasAccount('3a')" (click)="goTo(customer.temporary_accounts.length ? '/new-account/3a' : '/product')">
          {{ 'productSwitchDropdown.new3aAccount' | translate }} <span class="icon-i-plus-circle"></span>
        </li>
      </ng-container>
      <!-- end 3a pillar option -->
      <ng-container *ngIf="customer.app_location === 'ch'">
        <li class="navbar__sub-category">
          <span>{{ 'productSwitchDropdown.sectionTitle.grow' | translate }}</span>
        </li>
        <li
          (click)="switchAccount(findCustomerAccount('grow'))"
          *ngIf="hasAccount('grow')"
          [class.active]="currentAccount?.kind === 'grow' && !isCIActive"
        >
          <span class="icon-i-world"></span>{{ 'productSwitchDropdown.sectionTitle.grow' | translate }}
        </li>
        <li class="add-account" *ngIf="!hasAccount('grow')" (click)="goTo('/grow/intro')">
          {{ 'productSwitchDropdown.new3bAccount' | translate }} <span class="icon-i-plus-circle"></span>
        </li>
      </ng-container>

      <li class="navbar__sub-category">
        <span>{{ 'productSwitchDropdown.sectionTitle.3b' | translate }}</span>
      </li>
      <li (click)="switchAccount(findCustomerAccount('3b'))" *ngIf="hasAccount('3b')" [class.active]="currentAccount?.kind === '3b' && !isCIActive">
        <span class="icon-i-tree"></span>{{ 'productSwitchDropdown.3bAccount' | translate }}
      </li>
      <li
        class="add-account"
        *ngIf="!hasAccount('3b')"
        (click)="customer.app_location === 'ch' && customer.temporary_accounts.length ? goTo('/new-account/3b') : createNewAccount('3b')"
      >
        <span>{{ 'productSwitchDropdown.new3bAccount' | translate }} <span class="icon-i-plus-circle"></span></span>
      </li>
      <ng-container *ngIf="customer.app_location === 'ch' && hasAccount('3b')">
        <li class="navbar__sub-category">
          <span>{{ 'productSwitchDropdown.sectionTitle.i4k' | translate }}</span>
        </li>
        <ng-container *ngIf="kidsAccounts?.length > 0">
          <li
            *ngFor="let kidAccount of kidsAccounts"
            (click)="switchAccount(kidAccount)"
            [class.active]="currentAccount?.id === kidAccount.id && !isCIActive"
          >
            <span class="icon-i-sprout"></span>{{ kidAccount.owner_name }}
          </li>
        </ng-container>
        <li class="add-account" (click)="createKidsAccount()">
          <span class="icon-i-plus-circle"></span>
          {{ 'productSwitchDropdown.newKidsAccount' | translate }}
        </li>
      </ng-container>
      <ng-container *ngIf="customer.has_crowd_investor_account">
        <li class="navbar__sub-category">{{ 'productSwitchDropdown.sectionTitle.CI' | translate }}</li>
        <li (click)="switchCIAccount()" [class.active]="isActive('/ci-overview')">
          <span class="icon-i-windmill"></span>
          {{ 'productSwitchDropdown.sectionTitle.CI' | translate }}
        </li>
      </ng-container>
    </div>
  </div>
  <ul class="mobile-nav-bar__list">
    <!-- Category MAIN -->
    <ng-container *ngIf="showNavigation">
      <li *ngIf="currentAccount.step_status === 5" (click)="goTo('/reports/dashboard')" [class.active]="isActive('/reports')">
        <span>{{ 'nav.performance' | translate }}</span>
      </li>
      <li *ngIf="currentAccount?.kind !== 'grow'" [class.active]="isActive('/strategy')" (click)="goTo('/strategy')">
        <span>{{ 'nav.strategy' | translate }}</span>
      </li>
      <li *ngIf="currentAccount.step_status === 5" [class.active]="isActive('/adjust-investment')" (click)="goTo('/adjust-investment')">
        <span>{{ 'nav.adjust-investment' | translate }}</span>
      </li>
    </ng-container>

    <!-- Category SETTINGS -->
    <li class="navbar__sub-category" [ngClass]="{ first: onProductSwitch }">
      <span>{{ customer.first_name }} {{ customer.last_name }}</span>
    </li>
    <li [class.active]="isActive('/profile/settings')" (click)="goTo('/profile/settings')">
      <span class="icon-i-person"></span>{{ 'profile.settings' | translate }}
    </li>

    <li
      *ngIf="(currentAccount?.kind !== 'kid' && customer.temporary_accounts.length) || customer.has_crowd_investor_account"
      [class.active]="isActive('/profile/documents')"
      (click)="goTo('/profile/documents')"
    >
      <span class="icon-i-document"></span>{{ 'profile.docs' | translate }}
    </li>
    <li
      *ngIf="!customer.inyova_pro"
      (click)="goTo('/tell-friend'); trackActivity('[Link] Invite friends from navigation dropdown menu')"
      [class.active]="isActive('/tell-friend')"
    >
      <span class="icon-i-people"></span>{{ 'nav.tell_friend' | translate }}
    </li>

    <!-- Category HELP -->
    <li class="navbar__sub-category">
      <span>{{ '2fa.code.needHelp' | translate }}</span>
    </li>
    <li class="full_width" (click)="openFAQ()"><span class="icon-i-question"></span>FAQ</li>
    <li [class.active]="isActive('/help')" (click)="goTo('/help')"><span class="icon-i-phone"></span>{{ 'nav.contact' | translate }}</li>
    <li (click)="logout()"><span class="icon-i-logout"></span>{{ 'profile.logout' | translate }}</li>
  </ul>
</div>

<app-dialog-generating-spinner *ngIf="switchAccountSpinner" [title]="switchAccountSpinnerMessage" [showNav]="true"> </app-dialog-generating-spinner>
